import React, { useCallback, useEffect, useMemo, useRef, useState } from 'react';
import {EuiFlexGroup,EuiFlexItem, EuiFormRow, EuiFieldText, EuiButton, EuiSpacer, EuiTextColor, EuiSwitch, EuiButtonIcon, EuiCallOut} from '@elastic/eui';
import SelectorFecha from '../../../../../shared/components/Combos/Fecha';
import {ComboDireccionesNegocioContainer as ComboDirecciones} from '../../../components/Combos/DireccionesNegocio/container';
import SocPorcTable from './SocPorcTable';
import { CreateFechaMoment, ToSQL } from '../../../../../shared/utils/fecha';
import { HelpTooltip } from './help';
import "./styles.css";
import { PERFIL_ADMIN } from '../../../../../shared/constanst/constants';

export const Formulario = (props)=>{
  let {onSave, selected, onClose, currentUser, onGetProyectosByOferta, proyectoCRM, onResetProyectoCRM} = props
  const childRef = useRef();
  const sociedades = selected ? selected.sociedades : [];

  let [proyecto,setProyecto] = useState(selected ? selected.proyecto : undefined)
  let [fechaBaja, setFechaBaja] = useState(selected && selected.fechaBaja != null ? CreateFechaMoment(selected.fechaBaja) : null)
  let [esIngenieria, setIngenieria] = useState(selected ? selected.esIngenieria : false)
  let [codigo, setCodigo] = useState(selected ? selected.codigoProyecto : undefined)
  let [visible, setVisible] = useState(selected ? selected.visible : true)
  let [idDN, setIdDN] = useState(selected ? selected.idDN : undefined)
  let [codOferta, setCodOferta] = useState('');

  let[errorSoc, setErrorSoc] = useState(!selected);

  useEffect(()=>{
    if(!selected)
    {
      
      if(proyectoCRM)
      {
        const {code, name, diR_NEGOCIO_CODE, status, sociedaD_CODE} = proyectoCRM;
         const esUsuarioConPermiso = (currentUser && (currentUser.perfil!==PERFIL_ADMIN &&currentUser.administraUsuarios && sociedaD_CODE==='00007070') 
        || currentUser.perfil===PERFIL_ADMIN)
        if(status !== 'denegada' && esUsuarioConPermiso)
        {
          setCodigo(code);
          setProyecto(name);
          setIdDN(diR_NEGOCIO_CODE);
        }
      }else{
        setProyecto("")
        setFechaBaja(null)
        setIngenieria(false)
        setCodigo("")
        setVisible(true)
        setIdDN(undefined)
        setCodOferta('')
      }
    }
  },[proyectoCRM,selected,currentUser])

  const sociedadDefault = useMemo(() =>{
     if(!selected && proyectoCRM){
      const {status,sociedaD_CODE} = proyectoCRM;
      if(status !== 'denegada')
        return sociedaD_CODE
     }else return undefined
  },[proyectoCRM,selected])

  const getSocPorc = (conNombre,soc) => soc.map((s)=> {
    const data = {idSociedad:s.idSociedad, porcentaje:(s.porcentaje || 0), desarrollaIngenieria: s.desarrollaIngenieria}
    return !conNombre ?  data : {...{sociedad:s.sociedad},...data}
  })

  const getData = (sociedadesSelected) =>{
    if(selected){
      let newData = {...selected}
      let socPorc = getSocPorc(true,sociedadesSelected);
      let socModif = socPorc.map((sp)=> {
        const s = selected.sociedades.filter((f)=>f.idSociedad===sp.idSociedad && f.porcentaje===sp.porcentaje)
       return  s.length > 0 ? {...s[0], ...sp} : {...{idProyecto: selected.idProyecto},...sp}
      })

      newData.sociedades = [...socModif]
      newData.esIngenieria = esIngenieria;
      newData.proyecto = proyecto;
      newData.fechaBaja = (fechaBaja != null ? ToSQL(fechaBaja,"-") : null);
      newData.codigoProyecto = codigo;
      newData.visible = visible;
      newData.idDN =  (idDN!==undefined && idDN.length>0) ? idDN[0].value : undefined;

      return {...newData}
    }else{
      let socPorc = getSocPorc(false,sociedadesSelected);
      let data = {proyecto: proyecto, sociedades:socPorc, fechaBaja: (fechaBaja != null ? ToSQL(fechaBaja,"-") : null)
        , esIngenieria: esIngenieria, codigoProyecto: codigo, visible:visible, idDN:(idDN!==undefined && idDN.length>0) ? idDN[0].value : undefined}
      return data
    }
  }

  const onSaveData = () =>{
    let sociedadesSelected = childRef.current.getSociedades();
    if(!comprobarErrores() && sociedadesSelected.length>0){
      let newData = getData(sociedadesSelected);
      onSave && onSave(newData)
    }
  }


  const comprobarErrores = () => {
    return (isInvalidProyecto || isInvalidCodigo || isInvalidDN)
  }

  //const comprobarErroresSociedades = useCallback((error)=> (error===true),[])

  const getPerfilUser = useMemo(()=> currentUser.perfil,[currentUser])

  const configurationTextBoxCodigo = useMemo(()=>({
    maxLength:(getPerfilUser!==PERFIL_ADMIN?9:12),
    placeholder:(getPerfilUser!==PERFIL_ADMIN?'ej: 000-00000':'ej: 00-000-00000'),
    pattern:(getPerfilUser!==PERFIL_ADMIN?`[0-9]{3}\-[0-9]{5}`:`[0-9]{2}\-[0-9]{3}\-[0-9]{5}`)
  }),[getPerfilUser])

  const patternCodOferta = /^\d{2}-\d{3}-\d{5}$/;
   const patternCodOfertaHtml = "^\\d{2}-\\d{3}-\\d{5}$";

  const isInvalidProyecto = useMemo(() => {return proyecto===undefined || proyecto.trim()===""},[proyecto])
  const isInvalidCodigo = useMemo(() => {return codigo===undefined || codigo.trim()===""},[codigo])
  const isInvalidDN = useMemo(() => idDN===undefined || idDN.length===0,[idDN])

  const isInvalidCodOferta= useMemo(()=>{
    return !patternCodOferta.test(codOferta);
  },[codOferta])

  const msgProyectoCRMDenegado = useMemo(()=>{
    if(proyectoCRM){
    const {status} = proyectoCRM;
    return (status==='denegada')?
      <EuiFormRow fullWidth hasEmptyLabelSpace>
        <EuiCallOut size='s' color='danger' iconType={'crossInACircleFilled'} title="No se puede agregar una oferta que está denegada."/> 
      </EuiFormRow>
    : null;
    }
  },[proyectoCRM])

  const msgProyectoNoPermitido = useMemo(()=>{
    if(proyectoCRM &&(currentUser && currentUser.administraUsuarios)){
    const {sociedaD_CODE} = proyectoCRM;
    let msg = '';

    if(sociedaD_CODE !== '00007070')
        msg = "La oferta no esta asocieda a ESYP";
    // else{
    //   if(status==='denegada')
    //     msg="No se puede agregar una oferta que está denegada."
    // }

    return (msg!=='')?
      <EuiFormRow fullWidth hasEmptyLabelSpace>
        <EuiCallOut size='s' color='danger' iconType={'crossInACircleFilled'} title={msg}/> 
      </EuiFormRow>
    : null;
    }
  },[proyectoCRM, currentUser])

  const msgErrores = useMemo(()=>{
    let msg = '';
    msg = comprobarErrores() ? 'Faltan campos por rellenar.' : '';
    msg+= errorSoc?'Falta agregar sociedad(es).':'';

    return msg;
  },[comprobarErrores,errorSoc])
  
  // &&
  return (
    <>
    {!selected && currentUser && currentUser.login==="certifica"?
    <EuiFlexGroup>
        <EuiFlexItem>
          
          <EuiFlexGroup>
                <EuiFlexItem grow={false}>
                  <EuiFormRow fullWidth label="Código Oferta" isInvalid={isInvalidCodOferta}>
                    <EuiFieldText fullWidth value={codOferta} name="txtCodigoOferta" onChange={e => setCodOferta(e.target.value)} 
                    isInvalid={isInvalidCodOferta} 
                    placeholder={"00-000-00000"} pattern={patternCodOfertaHtml}/>
                  </EuiFormRow>
                  
                </EuiFlexItem>
                <EuiFlexItem grow={false}>
                  <EuiFormRow hasEmptyLabelSpace>
                  <EuiButtonIcon className='btn-proyectoCRM-search' iconType={'search'} isDisabled={isInvalidCodOferta} onClick={()=>{onGetProyectosByOferta(codOferta)}}/>
                  </EuiFormRow>
                </EuiFlexItem>
                <EuiFlexItem grow={false}>
                  <EuiFormRow hasEmptyLabelSpace>
                  <EuiButtonIcon className='btn-proyectoCRM-refresh' iconType={'refresh'}  onClick={()=>{onResetProyectoCRM()}}/>
                  </EuiFormRow>
                </EuiFlexItem>
                <EuiFlexItem>
                    {msgProyectoCRMDenegado}
                </EuiFlexItem>
          </EuiFlexGroup>
        </EuiFlexItem>
      </EuiFlexGroup>
    :null}

    <EuiFlexGroup>
      <EuiFlexItem>
        <EuiFormRow fullWidth label="Proyecto" isInvalid={isInvalidProyecto}>
          <EuiFieldText fullWidth value={proyecto} name="txtProyecto" onChange={e => setProyecto(e.target.value)} isInvalid={isInvalidProyecto}/>
        </EuiFormRow>
      </EuiFlexItem>
      <EuiFlexItem grow={false}>
          <EuiFormRow label="Visible" labelAppend={<HelpTooltip message="El proyecto es visible o no en la creación de partes."/>}>
            <EuiSwitch checked={visible} name="chkProyectoVisible" onChange={e => setVisible(!visible)} className="chkIngenieria"/>
          </EuiFormRow>
        </EuiFlexItem>
        <EuiFlexItem grow={false}>
          <EuiFormRow label="Ingeniería" labelAppend={<HelpTooltip message="Ingeniería diferenciada en la oferta"/>}>
            <EuiSwitch checked={esIngenieria} name="chkIngenieria" onChange={e => setIngenieria(!esIngenieria)} className="chkIngenieria"/>
          </EuiFormRow>
        </EuiFlexItem>
    </EuiFlexGroup>

    <EuiFlexGroup>
        <EuiFlexItem grow={false}>
          <EuiFormRow fullWidth label="Código" isInvalid={isInvalidCodigo}>
            <EuiFieldText fullWidth value={codigo} name="txtCodigoProyecto" onChange={e => setCodigo(e.target.value)} 
            isInvalid={isInvalidCodigo} maxLength={configurationTextBoxCodigo.maxLength} 
            placeholder={configurationTextBoxCodigo.placeholder} pattern={configurationTextBoxCodigo.pattern}/>
          </EuiFormRow>
        </EuiFlexItem>
        <EuiFlexItem grow={false}>
          <EuiFormRow fullWidth label="Fecha de baja">
            <SelectorFecha selected={fechaBaja} onChange={date => setFechaBaja(date)} onClear={() => setFechaBaja(null)}/>
          </EuiFormRow>
        </EuiFlexItem>
        <EuiFlexItem>
          <EuiFormRow fullWidth label="DN/SG" isInvalid={isInvalidDN}>
            <ComboDirecciones fullWidth isInvalid={isInvalidDN} selectedOptions={idDN} onChange={value => {setIdDN(value); }}/>
          </EuiFormRow>
        </EuiFlexItem>
    </EuiFlexGroup>

    <EuiFlexGroup>
      <EuiFlexItem>
      <EuiFormRow hasEmptyLabelSpace fullWidth>
        <SocPorcTable sociedadDefault={sociedadDefault} setError={setErrorSoc} sociedades={sociedades} ref={childRef} esIngenieriaProyecto={esIngenieria}/>
      </EuiFormRow>
      </EuiFlexItem>
    </EuiFlexGroup>

    {msgErrores!==''? 
    <EuiFlexGroup>
      <EuiFlexItem>
        <EuiFormRow fullWidth label="">
          <EuiTextColor color="danger"><br/>{`${msgErrores}`}</EuiTextColor>
        </EuiFormRow>
      </EuiFlexItem>
    </EuiFlexGroup>
    :null}
    <EuiSpacer size="m" />

    <EuiFlexGroup>
      <EuiFlexItem>
        <EuiButton onClick={onSaveData} disabled={msgErrores!==''}>
          Guardar
        </EuiButton>
      </EuiFlexItem>
      <EuiFlexItem>
        <EuiButton color="danger" onClick={()=>onClose()}>Cancelar</EuiButton>
      </EuiFlexItem>
    </EuiFlexGroup>
    </>
  )
}
export default Formulario;